






















































































































import { Component, Vue } from "vue-property-decorator";
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import axios from 'axios';
import { General } from '@/services/General';
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";
import { ClaimEnum } from '@/services/ClaimEnum';
import { DropDownItem } from "@/services/DropDownItem";
import LabelDetail from "./LabelDetail.vue";
import { MaterialLabelEntity } from "@/entity/MaterialLabel/MaterialLabelEntity";
import { Country } from "@/entity/Country";

@Component({
    components: {
      SearchFilter,
      LeftClickOptionMenu,
      LabelDetail
    }
  })
  export default class LabelRepositorySearch extends Vue {
    materialCode: string = null;
    materialName: string = null;
    idOem: string = null;
    idRegion: string = null;
    dropDownOem: any = new Array();
    dropDownRegion: any = new Array();
    filterSelected: boolean = false;
    showLoading: boolean = false;
    freeText = null;
    currentIdMaterialLabel: string = null;
    resultsItems: any = {
            resultPage: new Array(),
            total: 0
        };
    page: number = 1;
    firstSearch: boolean = false;
    
    async openLabel(item: MaterialLabelEntity){        
        this.currentIdMaterialLabel = item.id;
        this.openModal();
    }
    openModal(){
        this.$bvModal.show('label-details-modal');
    }
    closeModal(){
        this.$bvModal.hide('label-details-modal');
    }
    
    openCreate(){
        this.currentIdMaterialLabel = null;
        this.openModal();
    }

    isAdmin() {
        return General.CheckAuthorization(ClaimEnum.CanEditMaterialLabel);
    }
    getFileFrontUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/front/" + id);
    }
    getFileBackUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/back/" + id);
    }
    getPreviewFrontUrl(entity: MaterialLabelEntity) {
        return General.GetApiUrl("/api/MaterialLabel/download/front/preview/" + entity.id+ "?v="+entity.updateDate);
    }
    getPreviewBackUrl(entity: MaterialLabelEntity) {
        return General.GetApiUrl("/api/MaterialLabel/download/back/preview/" + entity.id+ "?v="+entity.updateDate);
    }
    getRegionsName(regions:Country[]){
        return regions.map(x=>x.name).join(', ');
    }
    searchFilterResetEvent() {
         
          this.resetFilters()
    }
    resetFilters() {
        this.materialCode = null;
        this.idOem = null;
        this.idRegion = null;
        
    }
    showUpdateDate(date:Date){
        return General.formatDateTime(date);
    }
    searchFilterSearchEvent(genericSearch: string) {
            if (genericSearch != null) 
                this.freeText = genericSearch;
            
            this.searchItems(true)
    }
    searchItems(start: boolean) {
        this.searchDo(start);
    }
    resetSearch() {
            this.firstSearch = false;
            this.resultsItems.resultPage.splice(0);
            this.page = 1;
    }
    handleClick (event, item) {
        (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
    }       
    async mounted() {
        this.dropDownOem = await this.getDropdownOem();
        this.dropDownRegion = await this.getDropdownCountries();

    } 
    async getDropdownOem(): Promise<Array<any>> {
        try{
            let item: DropDownItem = new DropDownItem();
            let itemList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Oem'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                response.data.forEach( element => {
                    item = new DropDownItem();
                    item.idDropDownItem = element.id;
                    item.itemText = element.name;

                    itemList.push(item);
                });
                return General.SetOptionsDropDown(itemList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
    async getDropdownCountries(): Promise<Array<any>> {
        try{
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/MaterialLabel/GetCountries'),{
                responseType: "json",
                withCredentials: true
                
            });
            if(response.data) {
                response.data.forEach( element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async searchDo(start: boolean) {
        this.showLoading = true;
        if (start == true){
            this.resetSearch();            
            //this.resetSelection();
        }
        try {
            let results  = await axios.get(
                General.GetApiUrl('/api/MaterialLabel'),               
                
                {
                    responseType: "json",
                    withCredentials: true,
                    params: {
                        FreeText: this.freeText,
                        MaterialCode: this.materialCode,
                        MaterialName: this.materialName,
                        OemId: this.idOem,
                        RegionId: this.idRegion,
                        CurrentPage: this.page,

                        
                    }
                }

            )
            
          this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
          this.resultsItems.total = results.data.total;

          this.firstSearch = true;
          this.page += 1;
         
          this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }
  }
